import { createContext } from 'react';

import type { ClickStreamMetadata } from '../../../constants/TouringClickStreamEvents';

type TourCalendarContextType = {
  canRescheduleTours?: boolean;
  clickStreamMetadata?: ClickStreamMetadata;
  lastActivatedAt?: number;
  listingAlias?: string;
  listingAddress?: string;
  propertyPhotoUrl?: string;
  refetchTouringData?: () => void;
};

const TourCalendarContext = createContext<TourCalendarContextType>({
  canRescheduleTours: false,
  clickStreamMetadata: undefined,
  lastActivatedAt: 0,
  listingAlias: '',
  listingAddress: '',
  propertyPhotoUrl: '',
  refetchTouringData: () => {},
});

export default TourCalendarContext;
